import * as React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import AppProvider from './Components/Universal/API/Context-API/AppProvider';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import { NativeBaseProvider } from "native-base";
// import { Pressable } from 'react-native-web';
import { HelmetProvider } from 'react-native-helmet-async';

import Navigator from './Components/Navigator/Navigator';

import { PortalProvider } from 'react-native-alves-portal';

import {
  BottomSheetModalProvider,
} from '@gorhom/bottom-sheet';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { DefaultTheme, PaperProvider, Provider } from 'react-native-paper';


// import { MenuProvider } from 'react-native-popup-menu';
import { APIProvider } from './Components/Universal/API/API';
import { getDataFromStorage } from './Components/Universal/API/Context-API/Storage/Storage';
import { CartProvider } from './Components/Universal/API/Context-API/CartContext';
import { NotificationsProvider } from './Components/Notifications/Context/NotificationsContext';

const theme = {
  ...DefaultTheme,
  colors: {
      ...DefaultTheme.colors,
      text: 'black'
  }
};


const NAVIGATION_STATE_KEY = '123'

const App: React.FC = () => {

   return (
    <HelmetProvider>
    {/* <MenuProvider> 👈 Ensure MenuProvider is wrapping everything */}
        <GestureHandlerRootView style={{ flex: 1 }}>
          <AppProvider>
            <APIProvider>
            <NativeBaseProvider>
              <SafeAreaProvider>
                <BottomSheetModalProvider>
                  <PaperProvider theme={theme}>
                  <PortalProvider>  
                    <NotificationsProvider>
                      <CartProvider>
                        <View style={{ flex: 1 }}>
                            <Navigator />
                        </View>
                      </CartProvider>
                    </NotificationsProvider>
                    </PortalProvider>
                  </PaperProvider>
                </BottomSheetModalProvider>
              </SafeAreaProvider>
            </NativeBaseProvider>
            </APIProvider>
          </AppProvider>
        </GestureHandlerRootView>
    {/* </MenuProvider> */}
    </HelmetProvider>
  );
};

export default App;
